import react from "react";
import Master from "./Master";

function About(){
    return(
        <Master>
               {/* Page Header Start */}
	<div class="page-header">
		<div class="container">
			<div class="row align-items-center">
				<div class="col-lg-12">
					{/* Page Header Box Start */}
					<div class="page-header-box">
						<h1 class="text-anime-style-2" data-cursor="-opaque"><span>About</span> Us</h1>
						<nav class="wow fadeInUp">
							<ol class="breadcrumb">
								<li class="breadcrumb-item"><a href="./">home</a></li>
								<li class="breadcrumb-item active" aria-current="page">about us</li>
							</ol>
						</nav>
					</div>
					{/* Page Header Box End */}
				</div>
			</div>
		</div>
	</div>
	{/* Page Header End */}

   {/* About Us Section Start */}
	<div className="about-us">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-6">
                    {/* About Image Start */}
                    <div className="about-image">
                        <div className="about-img-1">
                            <figure className="image-anime reveal">
                                <img src="images/about-us-img-1.jpg" alt=""/>
                            </figure>
                        </div>

                        <div className="about-img-2">
                            <figure className="image-anime reveal">
                                <img src="images/about-us-img-2.jpg" alt="" />
                            </figure>
                        </div>

                        {/* About Experience Circle Start */}
                        <div className="about-experience">
                            <figure>
                                <img src="images/about-experience-circle.png" alt="" />
                            </figure>
                        </div>
                        {/* About Experience Circle End */}
                    </div>
                    {/* About Image End */}
                </div>

                <div className="col-lg-6">
                    {/* About Content Start */}
                    <div className="about-content">
                        {/* Section Title Start */}
                        <div className="section-title">
                            <h3 className="wow fadeInUp">about us</h3>
                            <h2 className="text-anime-style-2" data-cursor="-opaque"><span>Your Journey</span> to a Healthier Smile Begins Here</h2>
                            <p className="wow fadeInUp" data-wow-delay="0.25s">City Dental Clinic, established in 2015, is committed to delivering exceptional dental care with a strong patient-first approach. We provide a wide range of comprehensive dental treatments, including preventive, restorative, cosmetic, and emergency care. Our clinic combines experienced dental professionals, advanced modern technology, and a compassionate approach to ensure accurate diagnosis, effective treatment, and long-term oral health. We focus on creating a comfortable and stress-free environment where every patient receives personalized care for a healthy and confident smile.</p>
                        </div>
                        {/* Section Title End */}

                        {/* About Us Body Start */}
                        <div className="about-us-body wow fadeInUp" data-wow-delay="0.5s">
                            <ul>
                                <li>experienced team</li>
                                <li>comprehensive services</li>
                                <li>state-of-the-art technology</li>
                                <li>emergency dental services</li>
                            </ul>
                        </div>
                        {/* About Us Body End */}

                    </div>
                    {/* About Content End */}
                </div>
            </div>
        </div>
    </div>
    {/* About Us Section End */}



    {/* How It Work Start */}
    <div className="how-it-work" style={{background:"#eff8ff"}}>
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-6">
                    {/* How It Work Image Start */}
                    <div className="how-it-work-img">
                        <figure className="reveal image-anime">
                            <img src="images/how-it-work-img.jpg" alt="" />
                        </figure>
                    </div>
                    {/* How It Work Image End */}
                </div>

                <div className="col-lg-6">
                    <div className="how-it-work-content">
                        {/* Section Title Start */}
                        <div className="section-title">
                            <h3 className="wow fadeInUp">how it work</h3>
                            <h2 className="text-anime-style-2" data-cursor="-opaque"><span>What We Do</span> for Your Teeth</h2>
                            <p className="wow fadeInUp" data-wow-delay="0.25s">We provide complete dental care including preventive, restorative, and cosmetic treatments to keep your teeth healthy and strong.</p>
                        </div>
                        {/* Section Title End */}

                        {/* How Work Accordion Start */}
                        
                        {/* FAQ Accordion Start */}
                        <div className="faq-accordion how-work-accordion" id="accordion">
                            {/* FAQ Item Start */}
                            <div className="accordion-item wow fadeInUp">
                                <div className="icon-box">
                                    <img src="images/icon-how-it-work-1.svg" alt="" />
                                </div>
                                <h2 className="accordion-header" id="heading1">
                                    <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapse1" aria-expanded="true" aria-controls="collapse1">
                                        book an appointment
                                    </button>
                                </h2>
                                <div id="collapse1" className="accordion-collapse collapse show" aria-labelledby="heading1"
                                    data-bs-parent="#accordion">
                                    <div className="accordion-body">
                                        <p>Schedule your visit easily and receive prompt, professional dental care at your convenience.</p>
                                    </div>
                                </div>
                            </div>
                            {/* FAQ Item End */}

                            {/* FAQ Item Start */}
                            <div className="accordion-item wow fadeInUp" data-wow-delay="0.25s">
                                <div className="icon-box">
                                    <img src="images/icon-how-it-work-2.svg" alt="" />
                                </div>
                                <h2 className="accordion-header" id="heading2">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                                        What conditions can manual therapy treat?
                                    </button>
                                </h2>
                                <div id="collapse2" className="accordion-collapse collapse" aria-labelledby="heading2"
                                    data-bs-parent="#accordion">
                                    <div className="accordion-body">
                                        <p>Manual therapy helps treat neck and back pain, joint stiffness, muscle tightness, sports injuries, and posture-related problems.</p>
                                    </div>
                                </div>
                            </div>
                            {/* FAQ Item End */}
                            
                            {/* FAQ Item Start */}
                            <div className="accordion-item wow fadeInUp" data-wow-delay="0.5s">
                                <div className="icon-box">
                                    <img src="images/icon-how-it-work-3.svg" alt="" />
                                </div>
                                <h2 className="accordion-header" id="heading3">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                                        expert care
                                    </button>
                                </h2>
                                <div id="collapse3" className="accordion-collapse collapse" aria-labelledby="heading3"
                                    data-bs-parent="#accordion">
                                    <div className="accordion-body">
                                        <p>Professional dental treatment delivered with skill, precision, and compassion.</p>
                                    </div>
                                </div>
                            </div>
                            {/* FAQ Item End */}
                        </div>
                        {/* FAQ Accordion End */}
                        {/* How Work Accordion End */}
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/* How It Work End */}

    {/* Why Choose Us Section Start */}
    <div className="why-choose-us" style={{background:"#ffffff"}}>
        <div className="container">
            <div className="row section-row">
                <div className="col-lg-12">
                    {/* Section Title Start */}
                    <div className="section-title">
                        <h3 className="wow fadeInUp">why choose us</h3>
                        <h2 className="text-anime-style-2" data-cursor="-opaque"><span>Diagnosis of</span> Dental Diseases</h2>
                        <p className="wow fadeInUp" data-wow-delay="0.25s">We are committed to sustainability. eco-friendly initiatives.</p>
                    </div>
                    {/* Section Title End */}
                </div>
            </div>

            <div className="row">
                <div className="col-lg-4 col-md-6 order-1">
                    {/* Why Choose Box Start */}
                    <div className="why-choose-box-1">
                        {/* Why Choose Item Start */}
                        <div className="why-choose-item wow fadeInUp">
                            {/* Icon Box Start */}
                            <div className="icon-box">
                                <img src="images/icon-why-us-1.svg" alt="" />
                            </div>  
                            {/* Icon Box End */}

                            {/* Why Choose Content Start */}
                            <div className="why-choose-content">
                                <h3>experienced doctor</h3>
                                <p>Highly skilled professionals delivering quality and trusted dental care.</p>
                            </div>
                            {/* Why Choose Content End */}
                        </div>
                        {/* Why Choose Item End */}

                        {/* Why Choose Item Start */}
                        <div className="why-choose-item wow fadeInUp" data-wow-delay="0.25s">
                            {/* Icon Box Start */}
                            <div className="icon-box">
                                <img src="images/icon-why-us-2.svg" alt="" />
                            </div>  
                            {/* Icon Box End */}

                            {/* Why Choose Content Start */}
                            <div className="why-choose-content">
                                <h3>personalized care</h3>
                                <p>Tailored dental treatments designed to meet each patient’s unique needs.</p>
                            </div>
                            {/* Why Choose Content End */}
                        </div>
                        {/* Why Choose Item End */}

                        {/* Why Choose Item Start */}
                        <div className="why-choose-item wow fadeInUp" data-wow-delay="0.5s">
                            {/* Icon Box Start */}
                            <div className="icon-box">
                                <img src="images/icon-why-us-3.svg" alt="" />
                            </div>  
                            {/* Icon Box End */}

                            {/* Why Choose Content Start */}
                            <div className="why-choose-content">
                                <h3>flexible payment options</h3>
                                <p>Convenient plans designed to make dental care affordable for everyone.</p>
                            </div>
                            {/* Why Choose Content End */}
                        </div>
                        {/* Why Choose Item End */}
                    </div>
                    {/* Why Choose Box Start */}
                </div>

                <div className="col-lg-4 order-lg-1 order-md-2 order-1">
                    {/* Why Choose Image Start */}
                    <div className="why-choose-image wow fadeInUp">
                        <figure>
                            <img src="images/why-choose-us-img.png" alt="" />
                        </figure>
                    </div>
                    {/* Why Choose Image End */}
                </div>

                <div className="col-lg-4 col-md-6 order-lg-2 order-md-1 order-2">
                    {/* Why Choose Box Start */}
                    <div className="why-choose-box-2">
                        {/* Why Choose Item Start */}
                        <div className="why-choose-item wow fadeInUp">
                            {/* Icon Box Start */}
                            <div className="icon-box">
                                <img src="images/icon-why-us-4.svg" alt="" />
                            </div>  
                            {/* Icon Box End */}

                            {/* Why Choose Content Start */}
                            <div className="why-choose-content">
                                <h3>emergency services</h3>
                                <p>Quick and reliable dental care for urgent pain and accidents.</p>
                            </div>
                            {/* Why Choose Content End */}
                        </div>
                        {/* Why Choose Item End */}

                        {/* Why Choose Item Start */}
                        <div className="why-choose-item wow fadeInUp" data-wow-delay="0.25s">
                            {/* Icon Box Start */}
                            <div className="icon-box">
                                <img src="images/icon-why-us-5.svg" alt="" />
                            </div>  
                            {/* Icon Box End */}

                            {/* Why Choose Content Start */}
                            <div className="why-choose-content">
                                <h3>positive patient reviews</h3>
                                <p>Trusted by patients for excellent care and satisfying treatment experiences.</p>
                            </div>
                            {/* Why Choose Content End */}
                        </div>
                        {/* Why Choose Item End */}

                        {/* Why Choose Item Start */}
                        <div className="why-choose-item wow fadeInUp" data-wow-delay="0.5s">
                            {/* Icon Box Start */}
                            <div className="icon-box">
                                <img src="images/icon-why-us-6.svg" alt="" />
                            </div>  
                            {/* Icon Box End */}

                            {/* Why Choose Content Start */}
                            <div className="why-choose-content">
                                <h3>latest technology</h3>
                                <p>Advanced dental equipment ensuring accurate, safe, and efficient treatments.</p>
                            </div>
                            {/* Why Choose Content End */}
                        </div>
                        {/* Why Choose Item End */}
                    </div>
                    {/* Why Choose Box Start */}
                </div>
            </div>
        </div>
        {/* Icon Start Image Start */}
        <div className="icon-star-image">
            <img src="images/icon-star.svg" alt="" />
        </div>
        {/* Icon Start Image End */}
    </div>
    {/* Why Choose Us Section End */}

        </Master>
    );
}
export default About;